import { define } from '../redux-request';
import api from '../../api/api';

export const GET_HEALTH = define('GET_HEALTH');

export function getHealthRequest(data) {
  return GET_HEALTH.request(() => api.getHealth(data));
}
